import {
    RECEIVE_ACTIVITY,
    RECEIVE_MULTIPLE_ACTIVITIES,
    REQUEST_ACTIVITY,
    REQUEST_CHARTS_ORDER,
    REQUEST_MULTIPLE_ACTIVITIES,
    RESET_ACTIVITY
} from 'actions/ActionTypes';
import {
    FETCH_ACTIVITIES_QUERY_FETCHING,
    FETCH_ACTIVITIES_QUERY_SUCCESS,
    FETCH_ACTIVITIES_QUERY_FAIL,
    requestActivity,
    receiveActivity
} from 'actions/activitiesActions';

/** @typedef {import('reducers/multiSportEdit/types/entity/RootState').RootState} RootState */
/** @typedef {import('reducers/multiSportEdit/types/dto/ActivityDataDTO').ActivityDataDTO } ActivityDataDTO */

/**
 * @typedef {{
 *  isFetching: boolean;
 *  activities: {
 *      data: any;
 *      fetching: boolean;
 *      success: boolean;
 *      error: boolean;
 *  }
 *  entities: { [activityId: string]: ActivityDataDTO }
 *  lastUpdated: number;
 *  chartOrder: any;
 * }} ActivitiesState
 */

/** @type {ActivitiesState} */
const INITIAL_STATE = {
    isFetching: false,
    activities: {
        data: null,
        fetching: false,
        success: false,
        error: false
    },
    entities: {},
    lastUpdated: undefined,
    chartOrder: {}
};

/**
 * @param {ActivitiesState} state
 * @param {ReturnType<typeof requestActivity>} action
 * @returns {ActivitiesState}
 */
const requestActivityActionHandler = (state, action) => {
    return {
        ...state,
        entities: {
            ...state.entities,
            [action.activityId]: undefined
        },
        isFetching: true
    };
};

/**
 * @param {ActivitiesState} state
 * @param {ReturnType<typeof receiveActivity>} action
 * @returns {ActivitiesState}
 */
const receiveActivityActionHandler = (state, action) => {
    return {
        ...state,
        isFetching: false,
        entities: {
            ...state.entities,
            [action.activityId]: action.activity
        },
        lastUpdated: action.receivedAt
    };
};

const receiveMultipleActivities = (state, action) => {
    return {
        ...state,
        isFetching: false,
        entities: {
            ...state.entities,
            activities: action.activities
        },
        lastUpdated: action.receivedAt
    };
};

const requestMultipleActivities = (state) => {
    return {
        ...state,
        isFetching: true,
        entities: INITIAL_STATE.entities
    };
};

const receiveChartOrder = (state, action) => {
    return {
        ...state,
        chartOrder: action.chartsOrder
    };
};

const fetchActivitiesSuccess = (success) => (state, action) => {
    return {
        ...state,
        activities: {
            ...state.activities,
            data: success ? action.data : null,
            fetching: false,
            success: success,
            error: !success
        }
    };
};

const fetchActivitiesFetching = (state, action) => {
    return {
        ...state,
        activities: {
            fetching: true
        }
    };
};

const resetToInitialState = () => INITIAL_STATE;

const handlers = {
    [REQUEST_ACTIVITY]: requestActivityActionHandler,
    [RECEIVE_ACTIVITY]: receiveActivityActionHandler,
    [RECEIVE_MULTIPLE_ACTIVITIES]: receiveMultipleActivities,
    [REQUEST_MULTIPLE_ACTIVITIES]: requestMultipleActivities,
    [RESET_ACTIVITY]: resetToInitialState,
    [REQUEST_CHARTS_ORDER]: receiveChartOrder,
    [FETCH_ACTIVITIES_QUERY_SUCCESS]: fetchActivitiesSuccess(true),
    [FETCH_ACTIVITIES_QUERY_FAIL]: fetchActivitiesSuccess(false),
    [FETCH_ACTIVITIES_QUERY_FETCHING]: fetchActivitiesFetching
};

/** @param {RootState} state */
export const getActivities = (state) => state.activities.entities;
export const getActivity = (state, activityId) => state.activities.entities[activityId];
export const getMultipleActivities = (state) => state.activities.entities.activities;
export const getFetchingActivitySummaryStatus = (state) => state.activities.isFetching;
export const getChartsOrder = (state) => state.activities.chartOrder;

export const getQuriedActivities = (state) => {
    return state.activities.activities.data;
};

export const isQueriedActivitiesSuccess = (state) => {
    return state.activities.activities.addSuccess;
};

export const isQueriedActivitiesError = (state) => {
    return state.activities.activities.addError;
};

export const isQueriedActivitiesFetching = (state) => {
    return state.activities.activities.fetching;
};

export default function activities(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
